import { Http } from "../axios/interceptors";

export const allSentEmails = async (param) =>
  Http("GET", `/Bitacora/EnvioCorreosGetList?`, param);

export const allLogins = async (param) =>
  Http("GET", `/Bitacora/Login?`, param);

export const allFilesStorage = async (param) =>
  Http("GET", `/Bitacora/FilesStorage?`, param);

export const allLogsSystem = async (param) =>
  Http("GET", `/LogsSistema/GetList?`, param);
